export const getVatRatePercent = (vatRate?: number) => (vatRate ?? 0) * 100
